<template>
	<div class="col-md-6 col-md-offset-3">
		<div class="panel panel-default drop-shadow">
			<div class="panel-heading panel-dark text-center">
				<b>SIGN UP</b>
			</div>

			<div  v-if='env != "production" '  class="panel-body">
				<div class="form-group">
					<div class="col-md-4">
						<label class="control-label text-right" style='padding-top:7px; width:100%;' >
							Name:
						</label>
					</div>
					<div class="col-md-8 text-left">
						<input  name="name"  type="text"  class="form-control" style='width:100%; v-align:middle;' autofocus
								v-validate="'min:6|max:50'"
								v-model="name"
						>
						<span class="text-danger align-left">{{ errors.first('name') }}</span>
					</div>
				</div>
				<br><br>

				<div class="form-group">
					<div class="col-md-4">
						<label class="control-label text-right" style='padding-top:7px; width:100%;' >
							* Email:
						</label>
					</div>
					<div class="col-md-8 text-left">
						<input  name="email"  type="text"  class="form-control" style='width:100%; v-align:middle;'
								v-validate="'required|max:250'"
								v-model="email"
						>
						<span class="text-danger">{{ errors.first('email') }}</span>
					</div>
				</div>
				<br><br>

				<div class="form-group">
					<div class="col-md-4">
						<label class="control-label text-right" style='padding-top:7px; width:100%;' >
							* Password:
						</label>
					</div>
					<div class="col-md-8 text-left">
						<input  name="password"  ref="password"  type="password"  class="form-control" style='width:100%; v-align:middle;'
								v-validate="'required|min:8|max:50'"
								v-model="password"
						>
						<span class="text-danger">{{ errors.first('password') }}</span>
					</div>
				</div>
				<br><br>

				<div class="form-group">
					<div class="col-md-4">
						<label class="control-label text-right" style='padding-top:7px; width:100%;' >
							Repeat Password:
						</label>
					</div>
					<div class="col-md-8 text-left">
						<input  name="c_password"  type="password"  class="form-control"  style='width:100%; v-align:middle;'
								v-model="c_password"
								v-validate="'required:true|confirmed:password'"
								data-vv-as="c_password"
						>
						<span class="text-danger">{{ errors.first('confirmPassword') }}</span>
					</div>
				</div>
				<br><br><br>

				<div class="col-md-4 text-right">
					<small>* required</small>
				</div>
				<div class="form-group mbn col-md-6">
					<button v-if="requesting == false"
							name="button"  type="submit"  class="btn btn-primary btn-block"
							@click="send_register()"
							:disabled="errors.any() || !is_complete"
					>Submit</button>

					<button v-else  disabled
						    name="button"  type="submit"  class="btn btn-primary btn-block">
						<i class="fas fa-circle-notch fa-spin"></i>
					</button>
				</div>
			</div>
			
			<div v-else  class="panel-body">
				<h3>Thank you for your interest in Filed Safely.</h3>
				<hr>
				<br><br>
				Currently registrations are "invitation only" for a short period of time.
				<br><br>
				If you would like to register, please get in touch. Visit the <router-link to="/contact">contact</router-link> page for ways to reach us.
				<br><br><br>
			</div>
		</div>
	</div>
</template>

<script>
//imports...

export default {
    components: {
    },

    data() {
        return {
			env: process.env.VUE_APP_ENV,

            requesting:   false,
            name:         "",
            email:        "",
            password:     "",
            c_password:   "",
        };
    },

    computed: {
        is_complete() {
            return this.name && this.email && this.password && this.c_password;
        },
    },

    mounted() {
        if (typeof this.$route.params.campaign_code != "undefined") {
            const postData = {
                campaign_code: this.$route.params.campaign_code
            };
		}
	},

    methods: {
        send_register() {
			this.requesting = true;
			
            //User Register Method
            this.$validator.validateAll()
            .then(() => {
                const postData = {
                    name:       this.name,
                    email:      this.email,
                    password:   this.password,
                    c_password: this.c_password
                };
				
                this.axios.post('api/register', postData)
                .then(response => {
					localStorage.setItem('api_token', response.data.api_token);
					this.$store.commit("USER_NAME", response.data.name);

					this.$parent.rerender_header();

					this.$notify({
						group:    'fs_success',
						title:    'Success',
						text:     'Registration successful',
						duration: 1000,
						type:     'success'
					});
					
					this.$router.push('/files');
                })
                .catch(error => {
					this.requesting = false;
			
					localStorage.removeItem('api_token');
					this.$store.commit("RESET");

                    var error_msg = '';
					if (error.response.data.message) {
						error_msg = error_msg + error.response.data.message + "<br>";	
					}
					
					if (error.response.data.error) {
						Object.keys(error.response.data.error).forEach(key => {
							error_msg = error_msg + error.response.data.error[key] + "<br>";
							
							// load api errors into client errors
							this.errors.add({
								field: key,
								msg:   error.response.data.error[key],
							});
						});
					}

                    this.$notify({
                        group: 'fs_danger',
                        title: 'Error',
                        text:  error_msg,
                        type:  'error'
                    });
                });
            })
            .catch(() => {
				this.requesting = false;
			
                this.$notify({
                    group: 'fs_danger',
                    title: 'Error',
                    text:  this.errors.all(),
                    type:  'error'
                });
            });
        }
    }
};
</script>
